import React from "react";

import { Drawer, Box } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";

import CustomIconButton from "./UI/Button/CustomIconButton";
import { headerStyles } from "./Header.styles";
import CustomTypography from "./UI/Typography/CustomTypography";

interface HeaderDrawerProps {
  isOpen: boolean;
  drawerMode: "menu" | "locations" | null;
  onClose: () => void;
  onBackToMenu: () => void;
  children: React.ReactNode;
}

/**
 * Header drawer converted to use header.styles.ts sx and MUI icons.
 * - Uses sx props from header.styles (drawerPaper, drawerRootContainer, ...)
 */
export function HeaderDrawer({
  isOpen,
  drawerMode,
  onClose,
  onBackToMenu,
  children,
}: HeaderDrawerProps) {
  const handleIconClick = () => {
    if (drawerMode === "menu") {
      onClose();
    } else if (drawerMode === "locations") {
      onBackToMenu();
    } else {
      onClose();
    }
  };

  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: headerStyles.drawerPaper,
      }}
    >
      <Box id="drawer-root-container-menu" sx={headerStyles.drawerRootContainer}>
        {/* Fixed Header with Close/Back Button */}
        <Box id="drawer-header-container" sx={headerStyles.drawerHeaderContainer}>
          <CustomIconButton
            size="small"
            onClick={handleIconClick}
            sx={headerStyles.closeButton}
            aria-label={drawerMode === "menu" ? "Close menu" : "Back"}
          >
            {drawerMode === "menu" ? (
              <CloseOutlinedIcon fontSize="small" />
            ) : (
              <ArrowBackOutlinedIcon fontSize="small" />
            )}
          </CustomIconButton>

          <CustomTypography variant="bodyLBold" sx={{ ml: 1 }}>
            {drawerMode === "menu" ? "Menu" : "Locations"}
          </CustomTypography>
        </Box>

        {children}
      </Box>
    </Drawer>
  );
}

export default HeaderDrawer;
